<sm-options-content-layout optionsWidthClass="width300" contentStyleClass="flex-col width100p">
    <ng-template #options>
        <p-panel class="height100p full-height flex-col" [header]="app.t('ProjectPlanning.options')">
            <p-selectbutton class="flex-item-fixed width100p mb-3" [options]="viewOptions" [(ngModel)]="selectedView" optionLabel="label" optionValue="value" (ngModelChange)="viewChanged()"/>
            @if (treeData != null) {
                <p-tree #treeElement class="flex-item-fill height400p full-height mb-1" [value]="treeData.items" [selectionMode]="'checkbox'" [filter]=true [filterBy]="'label'" [(selection)]="treeData.selected" (selectionChange)="calendarsChanged()">
                </p-tree>
            }
            <sm-form class="flex-item-fixed mt-3" [form]="form"></sm-form>
        </p-panel>
    </ng-template>

    <ng-template #content>
        @if (selectedView == 'table') {
            <div class="flex-item-fill flex-col height100p">
                <app-project-toolbar [showSummary]=true [summary]="summary">
                </app-project-toolbar>
                <sm-table class="flex-item-fill" [floatingFilter]=true [data]="table" headerAlign="center" columnWidthMode="contentNoExpand" [contentColumnMaxWidthRatio]="0.3" (onCellEditingStopped)="cellEdited($event)" (onRowDoubleClicked)="eventClicked($event)"></sm-table>
            </div>
        }
        @else {
            <div class="flex-item-fill flex-col width100p height100p">
                <app-project-toolbar [calendarWrapper]="calendarWrapper">
                </app-project-toolbar>
                <full-calendar #fc class="flex-item-fill pp-fullcal" [options]="calendarWrapper.options"></full-calendar>
            </div>
        }
    </ng-template>
</sm-options-content-layout>
